import { render } from "./direksi.vue?vue&type=template&id=b7d7952a"
import script from "./direksi.vue?vue&type=script&lang=js"
export * from "./direksi.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__